import React, { useEffect, useReducer, useState, useRef } from "react";
import { Container, Box, Grid, List, ListItem, ListItemText, TextField, Button, Typography, Paper, Avatar } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close'; // Import the Close icon from MUI icons
import SendIcon from '@mui/icons-material/Send';
import PersonIcon from '@mui/icons-material/Person';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import * as API from "../../api/SmsApi";
import theme from "../../themes/Theme"
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import GroupIcon from '@mui/icons-material/Group';
const CloseButton = ({ onClick }) => {
  return (
    <div
      className={'close-chat-thread-btn'}
      aria-label="close"
      onClick={onClick}
      style={{
        position: 'absolute',
        right: 15,
        top: 10,
        background: 'white',
        color: 'black',
        boxShadow: 'none',
        marginTop: '12px',
        height: '30px'
      }}
    >
      <CloseIcon sx={{ fontSize: '1.1em'}}/>
    </div>
  );
};

function ChatThread({ textMessageThreadId, messages, eligible, healthPlan, header, patient_uid, phoneNumber, supportAgentName, onClose }) {
  const [inputValue, setInputValue] = useState('');
  const [textMessages, setTextMessages] = useState(messages);
  const messagesEndRef = useRef()

  const sendMessage = async () => {
    if (inputValue.replace(/\s+/, "")  == '') {
      alert('Please enter a valid message!');
      return;
    }
    let response = await API.putTextMessageThread({
      body: inputValue,
      id: textMessageThreadId,
      phone_number: phoneNumber
    });

    if(response) {
      setInputValue('');
    }
  };

  useEffect((el) => {
    messagesEndRef.current?.scrollIntoView({behavior: 'instant',block: 'end'});
  });

  const TextMessageThreadContainer = ({messagesEndRef, textMessages}) => {
    return(
      <Paper sx={{ height: 'auto', maxHeight: '60vh', overflowY: 'auto' }}>
        <List ref={messagesEndRef}>
          {textMessages && textMessages.map((message) => (
            <ListItem
              key={message.id}
              sx={{
                display: 'flex',
                justifyContent: message.from_wellportal ? 'flex-end' : 'flex-start',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: message.from_wellportal ? 'row-reverse' : 'row',
                  alignItems: 'left',
                  gap: 1,
                }}
              >
                <Avatar style={{ bgcolor: "#aaa"}} sx={{ color: '#aaa'}}>
                  {message.from_wellportal != true && <PersonIcon />}
                  {message.from_wellportal == true && <SupportAgentIcon />}
                </Avatar>
                <Paper
                  elevation={1}
                  sx={{
                    fontSize: '0.5em',
                    padding: 1,
                    backgroundColor: message.from_wellportal ?  theme.palette.primary.light : theme.palette.secondary.light,
                    borderRadius: message.from_wellportal ? '15px 15px 0 15px' : '15px 15px 15px 0',
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography variant="body2" style={{ color: '#111', fontSize: '4em' }}>
                        { message.body }
                      </Typography>
                    }
                    secondary={
                      <Typography variant="body2" style={{ color: '#111', marginTop: '5px', fontSize: '3em' }}>
                        Sent { message.created_at } { message.source == 'support_agent' ? `by ${ message.support_agent }` : '' }
                      </Typography>
                    }
                    sx={{ fontSize: '0.5em', color: message.from_wellportal ? 'white' : 'black' }}
                  />
                </Paper>
              </Box>
            </ListItem>
          ))}
        </List>
      </Paper>
    );
  }

  return (
    <Paper elevation={3} className='chat-thread-container'>
      <Box sx={{ width: 600, margin: 'auto' }}>
        <div className='chat-thread-header' style={{ marginTop: '5px', padding: '10px'}}>
          <Typography variant="h4" align="left" gutterBottom>
            <span>
              <Avatar style={{ verticalAlign: 'middle', display: 'inline', marginRight: '15px', bgcolor: "#aaa"}} sx={{ color: '#aaa'}}>
                <PersonIcon style={{ color: 'black', fontSize: '2.2em', verticalAlign: 'top' }}/>
              </Avatar>
              <span style={{ fontSize: '20px', fontWeight: 'bold', verticalAlign: 'top' }}>
                { patient_uid ? (<>
                  <a target='_blank' href={`/physicians/patient_info/${ patient_uid }`}>{header}</a>
                </>) : header}
              </span>
            </span>
            {
              eligible == true ? (
                <span style={{fontSize: '12px', marginLeft: '10px', fontWeight: 'bold', verticalAlign: 'top' }}>
                  <CheckCircleIcon style={{ fontSize: '25px', color: theme.palette.secondary.main,  verticalAlign: 'bottom' }} />
                  <span style={{ marginLeft: '5px' }}> Eligible </span>
                </span>
              ) : ''
            }
            {
              healthPlan  ? (
                <span style={{fontSize: '12px', marginLeft: '10px', fontWeight: 'bold', verticalAlign: 'top' }}>
                  <GroupIcon style={{ fontSize: '25px', color: theme.palette.secondary.main,  verticalAlign: 'bottom' }} />
                  <span style={{ marginLeft: '5px' }}> { healthPlan } </span>
                </span>
              ) : ''
            }
            <CloseButton className={'text-message-thread-close-btn'} onClick={ onClose }/>
          </Typography>
        </div>
        <TextMessageThreadContainer messagesEndRef={messagesEndRef} textMessages={ textMessages } />
        <Grid container sx={{ width: '600px', width: '100%', display: 'flex' }}>
          <Grid item xs={12} md={8} sx={{ paddingTop: 2 }}>
            <TextField
              fullWidth
              multiline
              variant='standard'
              rows={2}
              inputProps={{
                style: {
                  lineHeight: '1.5', // Adjust the line height here
                },
              }}
              size="small"
              placeholder="Type a message..."
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4} sx={{ paddingTop: 2, paddingLeft: 2 }}>
            <Button
              style={{ margin: '3px', float: 'right'}}
              size="small"
              onClick={sendMessage} variant="contained" color="primary">
              <SendIcon /> Send
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};
export default ChatThread;
